import { useEffect, useMemo, useState } from 'react'
import { VisibilityState } from '@tanstack/react-table'

import { useAuthStore } from '@/store/auth-store'
import { useCombinedLogsTableStateStore } from '../store'
import { useDateStore } from '@/components/DateInput'
import { Role } from '@/types/auth'
import { COMBINED_LOGS_COLUMNS } from '../constant'
import { FilterType } from '@/types/logs'
import { isBefore, subDays } from 'date-fns'

export const useManageCombinedLogsColumns = () => {
    const [columnVisibility, setColumnVisibility] = useState<VisibilityState>({})
    const { filter } = useCombinedLogsTableStateStore()
    const { role } = useAuthStore()
    const { date } = useDateStore()
    const selectedDate = new Date(date)
    const yesterday = subDays(new Date(), 2)
    const isDateBeforeYesterday = isBefore(selectedDate, yesterday)

    const mileageClerkColumnVisibility = useMemo(() => {
        const state: VisibilityState = {}

        state[COMBINED_LOGS_COLUMNS.Delay] = false

        return state
    }, [])

    const columnsVisibilityByRole = useMemo<VisibilityState>(() => {
        let state: VisibilityState = {}

        state[COMBINED_LOGS_COLUMNS.Lock] = filter.type !== FilterType.DailyLog && isDateBeforeYesterday
        state[COMBINED_LOGS_COLUMNS.Unfinished] = filter.type !== FilterType.DailyLog
        const canSeeFlaggedColumn = role === Role.MileageClerk || role === Role.PerformanceManager
        state[COMBINED_LOGS_COLUMNS.Flag] = canSeeFlaggedColumn
        state[COMBINED_LOGS_COLUMNS.LogActions] = filter.type === FilterType.DailyLog

        if (role === Role.MileageClerk) {
            state = { ...state, ...mileageClerkColumnVisibility }
        }
        return state
    }, [mileageClerkColumnVisibility, filter.type, role, isDateBeforeYesterday])

    useEffect(() => {
        setColumnVisibility(columnsVisibilityByRole)
    }, [columnsVisibilityByRole])

    return columnVisibility
}
